import { render, staticRenderFns } from "./BackDoor.vue?vue&type=template&id=3447ed07&"
import script from "./BackDoor.vue?vue&type=script&lang=js&"
export * from "./BackDoor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports